export const CAMBIAR_ESTADO = 'CAMBIAR_ESTADO';
export const ADD_DATA = 'ADD_DATA';
export const CLOSE_MODAL = 'CLOSE_MODAL';